import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { map } from "rxjs/operators";
import { AppSettings } from "../../../config/config";
import { apiConstants } from "../../constant/apiConstant";

export interface PendingFeeClassRow {
  classNumber: string;
  classDivision: string;
  classId: string;
  totalActiveStudentCount: number;
  activeStudentTotalPendingAmount: number;
  activeStudentPendingCount: number;
}

export interface GetOverdueClassListResponse {
  status: boolean;
  message?: string;
  body?: {
    reportClassData: PendingFeeClassRow[];
    lastUpdatedOn: string;
  };
}

export interface StudentFeeDetails {
  PendingAmount: number;
}

export interface StudentFeeOverdueRecord {
  studentId: string;
  studentName: string;
  studentImage: string | null;
  rollNumber: string;
  isBlocked: 0 | 1;
  feeDetails: StudentFeeDetails;
}

export interface GetOverdueStudentListResponse {
  status: boolean;
  message?: string;
  body?: {
    studentFeesOverdueData: StudentFeeOverdueRecord[];
    totalActiveStudentPendingCount: number;
    totalDeactiveStudentPendingCount: number;
    totalActiveStudentPendingAmount: number;
    totalPendingAmount: number;
  };
}

export interface StudentFeeDetailLine {
  label: string;
  value: number;
}

export interface StudentFeeTermDetail {
  isPaid: boolean;
  TermName: string | null;
  typename: string | null;
  DueDate: string;
  PaymentDate?: string; // present on paid items only
  feeStatus: string;
  colorCode: string;
  studentFeeDetail: StudentFeeDetailLine[];
}

export interface GetOverdueStudentHistoryResponse {
  status: boolean;
  message?: string;
  body?: {
    totalAmount: number;
    pendingAmount: number;
    paidAmount: number;
    percentagePendingAmount: number;
    feesDetail: StudentFeeTermDetail[];
  };
}

@Injectable({ providedIn: 'root' })
export class StaffFeesPendingReportService {
  private url = AppSettings.API_ENDPOINT_STAFF;

  constructor(private http: HttpClient) {}

  getOverdueClassList(staffId: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('lang', 'en');
    return this.http
      .get<GetOverdueClassListResponse>(this.url + apiConstants.getOverdueClassList, { params })
      .pipe(map((res) => res));
  }

  getOverdueStudentList(staffId: number | string, classId: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('classId', String(classId))
      .set('lang', 'en');
    return this.http
      .get<GetOverdueStudentListResponse>(this.url + apiConstants.getOverdueStudentList, { params })
      .pipe(map((res) => res));
  }

  getOverdueStudentHistory(staffId: number | string, classId: number | string, studentId: number | string) {
    const params = new HttpParams()
      .set('staffId', String(staffId))
      .set('classId', String(classId))
      .set('studentId', String(studentId))
      .set('lang', 'en');
    return this.http
      .get<GetOverdueStudentHistoryResponse>(this.url + apiConstants.getOverdueStudentListHistory, { params })
      .pipe(map((res) => res));
  }

  refreshFeesData(staffId: number | string) {
    const body = { staffId, lang: 'en' };
    return this.http
      .post<{ status: boolean; body?: { message: string } }>(this.url + apiConstants.refreshFeesData, body)
      .pipe(map((res) => res));
  }
}
